var map = {
	"./Acconts.jpg": 336,
	"./Administration.jpg": 337,
	"./Clinical-Trials-01.jpg": 338,
	"./DM.jpg": 339,
	"./Dietician.jpg": 340,
	"./House-keeping-01.jpg": 341,
	"./accounts-01.jpg": 342,
	"./call-center-01.jpg": 343,
	"./call-center.jpg": 344,
	"./dm-01.jpg": 345,
	"./front-desk-01.jpg": 346,
	"./front-desk-1.jpg": 347,
	"./house-keeping-010.jpg": 348,
	"./lab-01.jpg": 349,
	"./pharmacy-01.jpg": 350,
	"./photograpy-01.jpg": 351,
	"./technician-001.jpg": 352,
	"./technician-01.jpg": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 335;